import adminConstants from '../constants/admin.constant';

const togglePaymentView = {
  type: adminConstants.TOGGLE_PAYMENT_VIEW,
};

export default {
  togglePaymentView,
};
